@@include("./vendors/slick/slick.js");

var windowsPC = new RegExp('Windows NT');
var chromeOS = new RegExp('CrOS');

var hairHeight = Math.round($('.article-hair-start .intro-photo').height()*100) / 100,
    hairBottomMov = 'rotate(180deg) ' + 'translateY(-' + hairHeight +'px)',
    hairTopMov = 'translateY(-' + hairHeight + 'px)',
    bgmHeight = $('#bgm-canvas').height() + 400,
    hairScene,
    magicScene;

$('.article-plant-carousel').slick({
    infinite: true,
    speed: 500,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1333,
    pauseOnHover: false,
    fade: true,
    height: 'auto',
    cssEase: 'linear'
});

$('.slick-slider').click(function(){
    $(this).slick('slickNext');
})

var w = $(window);
var windowWidth = w.width();
var b = $("body").first();
var controller = new ScrollMagic.Controller();


// repsonsible for breaking titles into line length spans to better adjust backgrounds.
var titleBreaker = (function(){
    var $titles = $(".JS-title-breaker");
    var titles = [];

    $titles.each(createTitleObjects)
    for(var i in titles){
        titles[i].smallEle && createNewTitle(titles[i].element.width(), titles[i].smallEle, titles[i].smallText);
        titles[i].bigEle && createNewTitle(titles[i].element.width(), titles[i].bigEle, titles[i].bigText);
    }

    function createTitleObjects(){
        var $ele = $(this);
        var $smallEle = $ele.find(".small");
        var $bigEle = $ele.find(".big");
        var obj = {};
        obj.element = $ele;
        obj.resetElement = $ele.html();
        if($smallEle.length > 0){
            obj.smallEle = $smallEle;
            obj.smallText = $smallEle.html();
        }
        if($bigEle.length > 0){
            obj.bigEle = $bigEle;
            obj.bigText = $bigEle.html();
        }
        titles.push(obj);
    };
    function createNewTitle(parentWidth, element, text){
        var elementText = text.split(" ");
        var groups = [];

        addSpans()
        setTimeout(measureGroups(),100)
        setTimeout(formatText, 200)


        //  add spans for each word
        function addSpans(){
            element.addClass("test-width")
            element.html("")
            for(var i in elementText){
                element.append(" <span>"+elementText[i]+"</span> ".trim())
            }
        }
        // measures spans to know when to break text
        function measureGroups(){
            var position = 0;
            var count = 0;
            var currentGroup = false;

            element.find("span").each(function(){
                var span = $(this);
                var offset = span.offset().top;
                if(offset !== position){
                    position = offset;
                    currentGroup && groups.push(currentGroup)
                    currentGroup = [];
                }
                currentGroup.push(span.html());
            });
            groups.push(currentGroup);
        }
        function formatText(){
            element.html("")
            element.removeClass("test-width")
            for(var i in groups){
                element.append("<span>"+groups[i].join(" ")+"</span><br>");
            }
        }
    }
  $(window).on("resize", function(){
    if (windowWidth != w.width()){
      windowWidth = w.width();
      for(var i in titles){
        titles[i].smallEle && createNewTitle(titles[i].element.width(), titles[i].smallEle, titles[i].smallText);
        titles[i].bigEle && createNewTitle(titles[i].element.width(), titles[i].bigEle, titles[i].bigText);
      }
    }
  });
})();
  
var hairstyles = (function(){
    var container = $('section.article-hair-styles'),
        styles = ['hairstyle-1', 'hairstyle-2', 'hairstyle-3', 'hairstyle-4'],
        numStyles = styles.length,
        index = 0,
        loopStyles;

    loopStyles = setInterval(function() {
        container.removeClass('hairstyle-1 hairstyle-2 hairstyle-3 hairstyle-4');
        container.addClass(styles[index]);      
        index = (index + 1) % numStyles;
    }, 2000);

    $('.hairstyle-buttons').mouseenter(function(){
        clearInterval(loopStyles);
        container.removeClass('hairstyle-1 hairstyle-2 hairstyle-3 hairstyle-4');
        container.addClass($(this).data('style'));
    });
})();

if ($('html').hasClass('no-touchevents') || windowsPC.test(navigator.userAgent) || chromeOS.test(navigator.userAgent)) {
    var celebs = (function(){
        var container = $('section.article-hair-end');
        $('.celebs').mouseenter(function(){
            var celeb = $(this).data('celeb')
            container.removeClass('amandla zendaya yara viola solange lupita');
            container.addClass(celeb);
            $('.footer-photo').css('opacity', 0);
            $('.footer-photo.' + celeb).css('opacity', 1);
        });
    })();

    // Scroll Magic stuff
    setTimeout(combAnimation, 2000)
    setTimeout(hairAnimation, 2000)
    setTimeout(bgMagic, 2000)

    $('*[data-animation="fadeup"]').each(function(){
    var tweenFadeUp = new TweenLite.from(this, 0.66, {transform: 'translate3d(0, 25px, 0)', opacity: 0});
    var scene = new ScrollMagic.Scene({triggerHook: 0.75, triggerElement: this, offset: -150, reverse: false})
        .setTween(tweenFadeUp)
        .addTo(controller);
    });
    $('*[data-animation="fadein"]').each(function(){
        var tweenFadeIn = new TweenLite.from(this, 1, {opacity: 0});
        var scene = new ScrollMagic.Scene({triggerHook: 1, triggerElement: this, offset: -150, reverse: false})
            .setTween(tweenFadeIn)
            .addTo(controller);
    });
}

setTimeout(drawnAnimation, 2000)

function drawnAnimation(){
    $(".JS-drawn-pull-quote").each(function(){
        var ele = this;
        new ScrollMagic.Scene({
          triggerHook: 0.8,
          triggerElement: ele // starting scene, when reaching this element
        })
        .setClassToggle(ele, "drawn")
        .addTo(controller);
    });
}

function combAnimation(){
    $(".JS-combs").each(function(){
        var ele = this;
        new ScrollMagic.Scene({
          triggerHook: 0.8,
          triggerElement: ele // starting scene, when reaching this element
        })
        .setClassToggle(ele, "shown")
        .addTo(controller);
    });
}

function hairAnimation(){
  var hairTween = new TimelineLite()
    .to('.hair-bottom', 1, {transform: hairBottomMov }, 0)
    .to('.hair-top', 1, {transform: hairTopMov }, 0);
  hairScene = new ScrollMagic.Scene({
    triggerHook: 0.5,
    duration: hairHeight,
    triggerElement: '.article-hair-start'
    })
    .setTween(hairTween)
    .addTo(controller);
}


function bgMagic(){

  var images = {};

  var canvas = document.getElementById('bgm-canvas');
  var ctx = canvas.getContext('2d');

  canvas.width = parseInt(getComputedStyle(canvas).getPropertyValue('width'));
  canvas.height = parseInt(getComputedStyle(canvas).getPropertyValue('height'));

  var sources = [
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery_0.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery_1.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery2.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery3.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery4.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery5.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery6.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery7.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery8.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery9.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery10.jpg',
  '../assets/img/year-of-the-black-girl/BlackGirlMagic_Gallery11.jpg'
  ];

  loadImages(sources, function() {
    // console.log('images loaded');
  });

  function loadImages(sources, callback) {
    var loadedImages = 0;
    for(var i = 0; i < sources.length; i++) {
      var img = sources[i]+'';
      images[img] = new Image();
      images[img].onload = function() {
        if(++loadedImages >= sources.length) {
          callback(images);
        }
      };
      images[sources[i]].src = sources[i];
    }
  }


  var imageIndex = 0;
  function changeImage(){
    drawImg(images[sources[imageIndex]]);
    imageIndex = (imageIndex + 1) % sources.length;
  }

  var curProgress;
  magicScene = new ScrollMagic.Scene({triggerElement: '#bgm-canvas', duration: bgmHeight, offset: -200})
    .on('progress', function(e){
      if(Math.abs(e.progress.toFixed(1) - curProgress) > 0.025){
        changeImage();
      }
      curProgress = e.progress.toFixed(1);
    })
    .addTo(controller);

  function drawImg(img) {
    ctx.clearRect(0,0,canvas.width ,canvas.height); // clear canvas before painting

    var imageWidth = img.width;
    var imageHeight = img.height;
    var imgRatio = imageHeight / imageWidth;
    var canvasRatio = canvas.height / canvas.width;

    if (canvasRatio > imgRatio) {
        var finalHeight = canvas.height;
        var scale = finalHeight / imageHeight;
        var finalWidth = Math.round(imageWidth * scale , 0);
    } else {
        var finalWidth = canvas.width;
        var scale = finalWidth / imageWidth;
        var finalHeight = Math.round(imageHeight * scale , 0);
    }
    ctx.drawImage(img,((canvas.width - finalWidth) / 2),((canvas.height - finalHeight) / 2),finalWidth,finalHeight);
  }
};

function updateDuration(){
  hairHeight = Math.round($('.article-hair-start .intro-photo').height()*100) / 100;
  hairBottomMov = 'rotate(180deg) ' + 'translateY(-' + hairHeight +'px)';
  hairTopMov = 'translateY(-' + hairHeight + 'px)';
  bgmHeight = $('#bgm-canvas').height() + 400;
  if (hairScene){
    hairScene.duration(hairHeight);
  }
  if (magicScene){
    magicScene.duration(bgmHeight);
  }
};

$(window).on('resize', updateDuration);
